import AxiosInstance from "../services/networkServices";

/** Active season, season history and factor limits. */
export const getSeasonSettings = async () => {
  const response = await AxiosInstance.get("/admin/settings/season");
  return response.data;
};

/** Edit the active season (only the provided keys change). */
export const updateSeasonSettings = async (payload) => {
  const response = await AxiosInstance.put("/admin/settings/season", payload);
  return response.data;
};

/** Projected tier distribution after a reset at the given soft-reset factor. */
export const previewSeasonReset = async (factor) => {
  const response = await AxiosInstance.get("/admin/settings/season/preview-reset", {
    params: factor !== undefined ? { factor } : {},
  });
  return response.data;
};

/** End the active season now. `seasonName` must match the active season. */
export const runSeasonReset = async (seasonName) => {
  const response = await AxiosInstance.post("/admin/settings/season/run-reset", {
    confirm: true,
    seasonName,
  });
  return response.data;
};
